module.exports = __webpack_public_path__ + "img/logo-con.f403a42b.png";